import '../Authorization.css';
import React, { useState } from 'react';
import { isValidEmail, isValidPhoneNumber } from '../utils/verifyInputs';
import { InputType } from '../utils/InputType';
import { useLanguage } from '../LanguageContext';
import { getTranslation } from '../consts/translations';

interface LoginProps {
  inputPhoneOrEmail: string;
  setInputPhoneOrEmail: (phoneOrEmail: string) => void;
  onSendCode: () => void;
  loading: boolean;
  setShowVerification: (showVerification: boolean) => void;
  verificationError: string;
  setVerificationError: (error: string) => void;
  setInputType: (value: InputType) => void;
}

const Login: React.FC<LoginProps> = (props: LoginProps) => {
  const [phoneOrEmailValid, setPhoneOrEmailValid] = useState(false);
  const { language } = useLanguage();
  const translation = getTranslation(language);

  const handlePhoneNumberOrEmailInputChange = (e: any) => {
    props.setInputPhoneOrEmail(e.target.value);
    const validPhoneNumber = isValidPhoneNumber(e.target.value);
    const validEmail = isValidEmail(e.target.value);

    if (!(validPhoneNumber || validEmail)) {
      setPhoneOrEmailValid(false);
    } else {
      setPhoneOrEmailValid(true);
    }
  };

  const handlePhoneNumberOrEmailInputBlur = () => {
    const value = props.inputPhoneOrEmail;
    const validPhoneNumber = isValidPhoneNumber(value);
    const validEmail = isValidEmail(value);

    if (!(validPhoneNumber || validEmail)) {
      props.setVerificationError(translation.invalid_phone_number_or_email_error_message);
      setPhoneOrEmailValid(false);
    } else {
      props.setVerificationError('');
      setPhoneOrEmailValid(true);
      if (validPhoneNumber) props.setInputType(InputType.PhoneNumber);
      else props.setInputType(InputType.Email);
    }
  };

  return (
    <div className='login-container'>
      <div className='login-description'>{translation.login_description}</div>
      <input
        className='login-input'
        placeholder={translation.login_email_phone_placeholder}
        onChange={handlePhoneNumberOrEmailInputChange}
        onBlur={handlePhoneNumberOrEmailInputBlur}
        value={props.inputPhoneOrEmail}
      ></input>
      <button
        className={`login-button ${props.loading ? 'loading' : ''}`}
        disabled={props.loading || !phoneOrEmailValid}
        onClick={props.onSendCode}
      >
        {props.loading ? '' : translation.login_get_code_button_text}
      </button>
      <div className='login-verification-error'>{props.verificationError}</div>
    </div>
  );
};

export default Login;
